"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.purpleTheme = void 0;
const default_1 = __importDefault(require("./default"));
exports.purpleTheme = Object.assign(Object.assign({}, default_1.default), { name: 'purple', colors: Object.assign(Object.assign({}, default_1.default.colors), { css: Object.assign(Object.assign({}, default_1.default.colors.css), { primary: 'invert(14%) sepia(100%) saturate(4034%) hue-rotate(293deg) brightness(74%) contrast(113%)' }), main: {
            base: '#990099',
            tap: '#771483',
            hover: '#925499',
            focus: 'rgba(153,0,153,0.40)',
        }, accent: {
            base: '#990099',
        }, borders: Object.assign(Object.assign({}, default_1.default.colors.borders), { hover: '#990099' }) }) });
exports.default = exports.purpleTheme;
